// Environment-specific configuration
const environments = {
  development: {
    name: 'Development',
    apiUrl: 'http://localhost:5000',
    plaidEnv: 'sandbox',
    logLevel: 'debug',
    isDevelopment: true,
    isProduction: false
  },
  staging: {
    name: 'Testing',
    apiUrl: import.meta.env.VITE_API_URL || 'https://api.staging.mnymny.com',
    plaidEnv: 'sandbox',
    logLevel: 'info',
    isDevelopment: false,
    isProduction: false
  },
  production: {
    name: 'Production',
    apiUrl: import.meta.env.VITE_API_URL || 'https://api.mnymny.com',
    plaidEnv: 'production',
    logLevel: 'error',
    isDevelopment: false,
    isProduction: true
  }
};

// Get current environment
const getCurrentEnvironment = () => {
  // Detect environment based on hostname (more reliable than env vars)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Check if we're on staging
    if (hostname.includes('staging.mnymny.com')) {
      console.log('🔧 Environment detected: STAGING (from URL)');
      return environments.staging;
    }
    
    // Check if we're on localhost
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      console.log('🔧 Environment detected: DEVELOPMENT (from URL)');
      return environments.development;
    }
    
    // Otherwise, assume production
    console.log('🔧 Environment detected: PRODUCTION (from URL)');
    return environments.production;
  }
  
  // Fallback to env vars if window not available (SSR)
  const nodeEnv = import.meta.env.VITE_NODE_ENV || import.meta.env.NODE_ENV || 'development';
  console.log('🔧 Environment detected from env var:', nodeEnv);
  return environments[nodeEnv] || environments.development;
};

// Export current environment configuration
const config = getCurrentEnvironment();

export default config;

// Export individual environments for testing
export { environments, getCurrentEnvironment };

// Helper functions
export const isProduction = () => config.isProduction;
export const isDevelopment = () => config.isDevelopment;
export const getApiUrl = () => config.apiUrl;
export const getEnvironmentName = () => config.name;


